import * as React from "react";

const ConstrainedPageContent = (props: { className?: string; children: React.ReactNode }) => {
    return <div className={`constrained-page-content ${props.className || ""}`}>{props.children}</div>;
};

export default ConstrainedPageContent;
